import type { Window } from './window';

export class WindowManager {
  private windows: Window[] = [];
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
    this.container.addEventListener('pointerdown', (e) => {
      if (e.target === this.container) {
        for (const window of this.windows) {
          window.setActive(false);
        }
      }
    });
  }

  public addWindow(window: Window): void {
    window.on('focused', () => {
      this.bringToFront(window);
    });

    for (const window of this.windows) {
      window.setActive(false);
    }

    this.windows.push(window);
    this.bringToFront(window);
    this.container.appendChild(window.el);
  }

  public removeWindow(window: Window): void {
    const index = this.windows.indexOf(window);
    if (index !== -1) {
      this.windows.splice(index, 1);
      this.container.removeChild(window.el);
    }
  }

  private bringToFront(window: Window): void {
    const maxZIndex = this.windows.reduce((max, win) => {
      const zIndex = win.getZIndex();
      return Math.max(max, zIndex);
    }, 0);
    window.setZIndex(maxZIndex + 1);
    window.setActive(true);

    for (const win of this.windows) {
      if (win === window || win.parent === window) {
        continue;
      }

      win.setActive(false);
    }

    const childWindows = this.windows.filter((win) => win.parent === window);
    for (const [index, child] of childWindows.entries()) {
      child.setZIndex(maxZIndex + 2 + index);
      child.setActive(true);
    }

    if (window.parent) {
      this.bringToFront(window.parent);
      return;
    }

    // Make z-indexes contiguous
    this.windows.sort((a, b) => a.getZIndex() - b.getZIndex());
    for (const [idx, win] of this.windows.entries()) {
      win.setZIndex(idx + 1);
    }
  }
}
